@if (tree) {
  <campus-tree [treeItems]="tree" (selectionChange)="tocClick($event)"></campus-tree>
}
